// extracted by mini-css-extract-plugin
export var alignRight = "EmailAcquisitionForm-module--alignRight--6cfaa";
export var closeIcon = "EmailAcquisitionForm-module--closeIcon--a2bce";
export var confirmation = "EmailAcquisitionForm-module--confirmation--0f607";
export var emailInput = "EmailAcquisitionForm-module--emailInput--2f742";
export var exitIntent = "EmailAcquisitionForm-module--exitIntent--a9b5c";
export var formContainer = "EmailAcquisitionForm-module--formContainer--a504e";
export var formElements = "EmailAcquisitionForm-module--formElements--8cc63";
export var formSection = "EmailAcquisitionForm-module--formSection--c9ba3";
export var formWrapper = "EmailAcquisitionForm-module--formWrapper--2a10e";
export var gatewayInput = "EmailAcquisitionForm-module--gatewayInput--6b194";
export var heading = "EmailAcquisitionForm-module--heading--ca792";
export var hiddenFields = "EmailAcquisitionForm-module--hiddenFields--b1986";
export var imageBanner = "EmailAcquisitionForm-module--imageBanner--e2782";
export var inputContainer = "EmailAcquisitionForm-module--inputContainer--bfb4b";
export var inputWrapper = "EmailAcquisitionForm-module--inputWrapper--c3fb6";
export var legal = "EmailAcquisitionForm-module--legal--2a8d8";
export var link = "EmailAcquisitionForm-module--link--4a487";
export var message = "EmailAcquisitionForm-module--message--ef3da";
export var signUpFormAlert = "EmailAcquisitionForm-module--signUpFormAlert--57b04";
export var split = "EmailAcquisitionForm-module--split--71c52";
export var splitContainer = "EmailAcquisitionForm-module--splitContainer--f00d9";
export var submitButton = "EmailAcquisitionForm-module--submitButton--8e3f4";
export var subtitle = "EmailAcquisitionForm-module--subtitle--ca6af";